import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { LastItemInfo } from 'components-ref/atoms'

interface Props {
  isReel?: boolean
  isGoal?: boolean
}

export const LastPostInfo = ({ isReel = false, isGoal = false}: Props) => {
  const { t } = useTranslation()

  return (
    <Container $isGoal={isGoal}>
      <LastItemInfo
        text={t(isReel ? 'noMoreReels' : 'noMorePosts')}
      />
    </Container>
  )
}

const Container = styled.div<{ $isGoal: boolean }>`
  z-index: 6;
  display: flex;
  justify-content: center;

  ${({ $isGoal }) =>
    $isGoal
      ? `
        width: 100%;
        margin-bottom: 1.5rem;
      `
      : `
        position: absolute;
        width: 100%;
        margin: 0 auto;
        bottom: 13.5rem;
      `}

  animation: fadeOut 0.3s ease forwards;
  animation-delay: 2s;

  @keyframes fadeOut {
    to {
      opacity: 0;
    }
  }
`